import { useMutation } from '@tanstack/react-query'
import { withdrawFromEarn } from 'services/EarnService'
import { BaseErrorResponse } from 'types/beneficiaries'
import { TransferStatus, WithdrawalRequest, WithdrawalTransferResponse } from '../../types'
import { useEarnTracking } from '../useEarnTracking'

export const useWithdrawPortfolio = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (data: WithdrawalTransferResponse) => void
  onError?: (error: BaseErrorResponse) => void
}) => {
  const { trackSuccess, trackError } = useEarnTracking()
  const { mutate: withdrawFromPortfolio, isPending: isWithdrawingFromPortfolioPending } =
    useMutation({
      mutationFn: withdrawFromEarn,
    })

  const handleWithdrawFromPortfolio = (data: WithdrawalRequest) => {
    const { walletId, amount } = data

    return withdrawFromPortfolio(data, {
      onSuccess: data => {
        if (data.status !== TransferStatus.FAILED) {
          trackSuccess('withdraw', {
            walletId,
            amount,
          })
        }
        onSuccess?.(data)
      },
      onError: (error: BaseErrorResponse) => {
        trackError('withdraw', error, {
          walletId,
          amount,
        })
        onError?.(error)
      },
    })
  }

  return {
    withdrawFromPortfolio: handleWithdrawFromPortfolio,
    isWithdrawingFromPortfolioPending,
  }
}
